import React from 'react'
import { motion } from 'framer-motion'
import Tilt from 'react-parallax-tilt';

// Assuming fadeIn is defined somewhere else in your code
const fadeIn = (direction = "right", type = "spring", delay = 0, duration = 0.75) => {
  return {
    hidden: { opacity: 0, x: direction === "left" ? -100 : 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type,
        delay,
        duration,
      },
    },
  };
};

const Itemservices = ({ service, index }) => {
  return (
    <Tilt
      className="xs:w-[250px] w-[350px]"
      tiltMaxAngleX={45}
      tiltMaxAngleY={45}
      scale={1}
      transitionSpeed={450}
    >
      <motion.div
        variants={fadeIn('right', 'spring', 0.5 * index, 0.75)}
        initial="hidden"
        animate="visible"
        className="w-full green-pink-gradient p-[1px] rounded-[20px] shadow-card cursor-pointer"
      >
        <div className='bg-gradient-to-b from-black to-white rounded-[20px]  px-12 min-h-[280px] flex justify-evenly items-center flex-col'>
          <img src={service.icon} alt={service.title} className="w-20 h-20 object-contain" />
          <h1 className="text-black text-[25px] text-lg font-bold text-center">{service.title}</h1>
        </div>
      </motion.div>
    </Tilt>
  );
};

export default Itemservices;
